export const allegroAccountPermissionsConst = {
  view: {
    value: "view_account",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu konta!",
  },
  add: {
    value: "add_account",
    errorMsg: "Użytkownik nie ma uprawnień do dodania konta!",
  },
  update: {
    value: "change_account",
    errorMsg: "Użytkownik nie ma uprawnień do edycji konta!",
  },
  delete: {
    value: "delete_account",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania konta!",
  },
};

export const allegroConfigPermissionsConst = {
  view: {
    value: "view_configuration",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu konfiguracji!",
  },
  add: {
    value: "add_configuration",
    errorMsg: "Użytkownik nie ma uprawnień do dodania konfiguracji!",
  },
  update: {
    value: "change_configuration",
    errorMsg: "Użytkownik nie ma uprawnień do edycji konfiguracji!",
  },
  delete: {
    value: "delete_configuration",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania konfiguracji!",
  },
};

export const allegroOfferPermissionsConst = {
  view: {
    value: "view_offer",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu oferty!",
  },
  add: {
    value: "add_offer",
    errorMsg: "Użytkownik nie ma uprawnień do dodania oferty!",
  },
  update: {
    value: "change_offer",
    errorMsg: "Użytkownik nie ma uprawnień do edycji oferty!",
  },
  delete: {
    value: "delete_offer",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania oferty!",
  },
};

export const allegroSellerPermissionsConst = {
  view: {
    value: "view_accountseller",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu sprzedawcy!",
  },
  add: {
    value: "add_accountseller",
    errorMsg: "Użytkownik nie ma uprawnień do dodania sprzedawcy!",
  },
  update: {
    value: "change_accountseller",
    errorMsg: "Użytkownik nie ma uprawnień do edycji sprzedawcy!",
  },
  delete: {
    value: "delete_accountseller",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania sprzedawcy!",
  },
};

export const allegroSenderPermissionsConst = {
  view: {
    value: "view_accountsender",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu nadawcy!",
  },
  add: {
    value: "add_accountsender",
    errorMsg: "Użytkownik nie ma uprawnień do dodania nadawcy!",
  },
  update: {
    value: "change_accountsender",
    errorMsg: "Użytkownik nie ma uprawnień do edycji nadawcy!",
  },
  delete: {
    value: "delete_accountsender",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania nadawcy!",
  },
};

export const allegroCodReceiverPermissionsConst = {
  view: {
    value: "view_accountcashondeliveryreceiver",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu odbiorcy przelewu!",
  },
  add: {
    value: "add_accountcashondeliveryreceiver",
    errorMsg: "Użytkownik nie ma uprawnień do dodania odbiorcy przelewu!",
  },
  update: {
    value: "change_accountcashondeliveryreceiver",
    errorMsg: "Użytkownik nie ma uprawnień do edycji odbiorcy przelewu!",
  },
  delete: {
    value: "delete_accountcashondeliveryreceiver",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania odbiorcy przelewu!",
  },
};

export const allegroResponsibleProducerPermissionsConst = {
  view: {
    value: "view_accountresponsibleproducer",
    errorMsg:
      "Użytkownik nie ma uprawnień do odczytu osoby odpowiedzialnej za produkt!",
  },
  add: {
    value: "add_accountresponsibleproducer",
    errorMsg:
      "Użytkownik nie ma uprawnień do dodania osoby odpowiedzialnej za produkt!",
  },
  update: {
    value: "change_accountresponsibleproducer",
    errorMsg:
      "Użytkownik nie ma uprawnień do edycji osoby odpowiedzialnej za produkt!",
  },
  delete: {
    value: "delete_accountresponsibleproducer",
    errorMsg:
      "Użytkownik nie ma uprawnień do usuwania osoby odpowiedzialnej za produkt!",
  },
};

export const allegroSafetyInformationPermissionsConst = {
  view: {
    value: "view_accountproductsafetyinformation",
    errorMsg:
      "Użytkownik nie ma uprawnień do odczytu informacji o bezpieczeństwie produktu!",
  },
  add: {
    value: "add_accountproductsafetyinformation",
    errorMsg:
      "Użytkownik nie ma uprawnień do dodania informacji o bezpieczeństwie produktu!",
  },
  update: {
    value: "change_accountproductsafetyinformation",
    errorMsg:
      "Użytkownik nie ma uprawnień do edycji informacji o bezpieczeństwie produktu!",
  },
  delete: {
    value: "delete_accountproductsafetyinformation",
    errorMsg:
      "Użytkownik nie ma uprawnień do usuwania informacji o bezpieczeństwie produktu!",
  },
};

export const allegroOfferMessagesConst = {
  add: "Dodano ofertę!",
  update: "Oferta została zaktualizowana!",
  delete: "Oferta została usunięta!",
  error: "Wystąpił bład!",
};

export const allegroConfigMessagesConst = {
  error: "Wystąpił bład!",
  noConfigurationError:
    "Konto nie ma zapisanej konfiguracji połączenia, uzupełnij w ustawieniach konta Allegro.",
  createDeviceFlowSuccess:
    "Wygenerowano poprawnie kod urządzenia, przejdź do Allegro aby potwierdzić dostęp systemu do zasobów Konta Allegro.",
  accessTokenRevokeError:
    "Nie możesz rozłączyć aplikacji, konto nie ma ważnego tokenu dostępowego.",
  accessTokenRetriveSuccess:
    "Połączenie konta zostało poprawnie potwierdzone w Allegro",
  accessTokenRevokeSuccess: "Połączenie konta z Allegro zostało zakończone",
  revokedTokenInvalidEmailError:
    "Adres e-mail konta z którym próbujesz się połączyć nie zgadza się z adresem wprowadzonym w panelu admina.",
  revokedTokenInvalidAccountIdError:
    "To konto Allegro jest inne niż to, które zostało wcześniej połączone. Upewnij się, że logujesz się na właściwe konto.",
};

export const allegroOfferCmdTypeConst = {
  deliveryHandlingTimeModification: "DELIVERY_HANDLING_TIME_MODIFICATION",
  priceModification: "PRICE_MODIFICATION",
};

export const allegroOfferCmdMessageConst = {
  changeDeliveryTime: "Pomyślnie zaktualizowano czas wysyłki!",
  changePrice: "Pomyślnie zaktualizowano cenę!",
};

export const allegroOfferCmdConst = {
  ownPriceOpt: "own_price",
  modifyOwnPriceOpt: "modify_own_price",
  additionOperationOpt: "addition",
  substractOperationOpt: "substract",
  priceModificatorOpt: "price",
  percentageModificatorOpt: "percentage",
  modifyTypeOpts: [
    { value: "own_price", name: "ustaw swoją cenę" },
    {
      value: "modify_own_price",
      name: "dodaj lub odejmij kwotę lub procent od obecnej ceny",
    },
  ],
  operationOpts: [
    { value: "addition", name: "dodaj" },
    { value: "substract", name: "odejmij" },
  ],
  modificatorOpts: [
    { value: "price", name: "kwotę" },
    { value: "percentage", name: "procent" },
  ],
};

export const allegroThreadMessagesConst = {
  add: "Dodano wiadomość w wątku!",
};

export const allegroThreadPermissionsConst = {
  view: {
    value: "view_thread",
    errorMsg: "Użytkownik nie ma uprawnień do odczytu wiadomości!",
  },
  add: {
    value: "add_thread",
    errorMsg: "Użytkownik nie ma uprawnień do dodania wiadomości!",
  },
  update: {
    value: "change_thread",
    errorMsg: "Użytkownik nie ma uprawnień do edycji wiadomości!",
  },
  delete: {
    value: "delete_thread",
    errorMsg: "Użytkownik nie ma uprawnień do usuwania wiadomości!",
  },
};
